import { useCallback, useMemo } from 'react'
import DropdownList, { DropdownListOnChange } from '../../components/DropdownList'
import FormItem from '../../components/FormItem'
import { withCard } from '../../components'
import { AdminResponse } from '../../api/admins'
import { Modification, NewLaw, NewLawsCardState } from '../../api/cards'
import Button from '../../components/Button'

const statuses = [
  { id: 'NEW', title: 'Új' },
  { id: 'IN_PROGRESS', title: 'Folyamatban' },
  { id: 'DONE', title: 'Készen van' },
  { id: 'APPROVED', title: 'Jóváhagyva' },
  { id: 'CLOSED', title: 'Lezárva' },
]

const handlerStatuses = [
  { id: 'ERDEKES', title: 'Érdekes' },
  { id: 'NEM_ERDEKES', title: 'Nem érdekes' },
  { id: 'KEZELVE', title: 'Kezelve' },
]

//type NewLawsPaneOnChange = DropdownListOnChange | ((value: string[] | string, name: string) => void)

const NewLawItem = ({
  law,
  onChange = () => {},
}: {
  law: NewLaw
  onChange: (value: string, id: number) => void
}) => {
  return (
    <div className="pb-6">
      <div className="inline-block">
        <DropdownList
          name="status"
          value={law.status}
          list={handlerStatuses}
          onChange={(value, name) => onChange(value, law.publishedLawId)}
        />
      </div>
      <a href={law.url} target="_blank">
        <span className={`${law.relevance === 'NEM_RELEVANS' ? 'text-gray-400' : ''}`}>
          <b>{law.text}</b>&nbsp;{law.title}
        </span>
      </a>
    </div>
  )
}

const getKozlonyURL = (issueYear: string, issueNumber: number) =>
  `http://www.kozlonyok.hu/nkonline/MKPDF/hiteles/MK${issueYear.substring(0, 2)}${issueNumber}.pdf`

const NewLawsPane = ({
  card,
  admins,
  onChange = (id, value, name) => {},
  onLawChange = (id, value, lawId) => {},
  onSave = (id) => {},
}: {
  card: NewLawsCardState
  admins: AdminResponse[]
  onChange: (id: number, value: string | string[] | number, name: string) => void
  onLawChange: (id: number, value: string | number, lawId: number) => void
  onSave: (id: number) => void
}) => {
  const { id, status, newLaws, assignedTo, issueYear, issueNumber, issueDate, isModified } = card

  const _admins = useMemo(() => {
    return admins.map((admin: AdminResponse) => ({
      id: admin.id,
      title: admin.name,
    }))
  }, [admins])

  const handleChange = useCallback(
    (value: string[] | string, name: string) => {
      if (name === 'assignedTo') return onChange(id, Number.parseInt(value as string), name)
      onChange(id, value, name)
    },
    [id],
  )

  const handleSave = () => {
    onSave(id)
  }

  return (
    <div>
      <span className="text-xs">{id}</span>
      <div>
        <span className="text-sm">
          Közlöny:{' '}
          <a href={getKozlonyURL(issueYear, issueNumber)} target="_blank">
            {issueYear}/{issueNumber} ({issueDate})
          </a>
        </span>
      </div>
      <FormItem label="Státusz:">
        <DropdownList name="status" value={status} list={statuses} onChange={handleChange} />
        {status !== 'CLOSED' && (
          <Button title="Lezárva" onClick={() => handleChange('CLOSED', 'status')} />
        )}
      </FormItem>
      <ul>
        {newLaws.map((law) => (
          <li>
            <NewLawItem law={law} onChange={(value, lawId) => onLawChange(id, value, lawId)} />
          </li>
        ))}
      </ul>
      <FormItem label="Delegálva:">
        <DropdownList name="assignedTo" value={assignedTo} list={_admins} onChange={handleChange} />
      </FormItem>

      <div className="flex flex-row items-center">
        {isModified === Modification.Modified ? (
          <Button title="Ment" onClick={handleSave} />
        ) : isModified === Modification.Saved ? (
          'Mentve'
        ) : null}
      </div>
    </div>
  )
}

export default withCard(NewLawsPane)
